export const INIT_ADYEN = 'INIT_ADYEN'
export const GET_ADYEN_PAYMENT_AUTHORIZATION = 'GET_ADYEN_PAYMENT_AUTHORIZATION'
export const GET_ADYEN_PAYMENT_AUTHORIZATION_DETAILS = 'GET_ADYEN_PAYMENT_AUTHORIZATION_DETAILS'
export const SET_ADYEN_STATE_PROVINCE_SHOWN = 'SET_ADYEN_STATE_PROVINCE_SHOWN'
export const SET_ADYEN_DROP_IN_READY = 'SET_ADYEN_DROP_IN_READY'
export const SET_ADYEN_DROP_IN_ERROR = 'SET_ADYEN_DROP_IN_ERROR'
export const SET_ADYEN_PROCESSING = 'SET_ADYEN_PROCESSING'
export const RESET_ADYEN = 'RESET_ADYEN'

export function initAdyen () {
  return {
    type: INIT_ADYEN,
  }
}

export function getAdyenPaymentAuthorization (options) {
  return {
    type: GET_ADYEN_PAYMENT_AUTHORIZATION,
    payload: options,
  }
}

export function getAdyenPaymentAuthorizationDetails (options) {
  return {
    type: GET_ADYEN_PAYMENT_AUTHORIZATION_DETAILS,
    payload: options,
  }
}

export function setAdyenStateProvinceShown (value) {
  return {
    type: SET_ADYEN_STATE_PROVINCE_SHOWN,
    payload: value,
  }
}

export function setAdyenDropInReady (value) {
  return {
    type: SET_ADYEN_DROP_IN_READY,
    payload: value,
  }
}

export function setAdyenDropInError (error) {
  return {
    type: SET_ADYEN_DROP_IN_ERROR,
    payload: error,
  }
}

export function setAdyenProcessing (processing = false) {
  return {
    type: SET_ADYEN_PROCESSING,
    payload: processing,
  }
}

export function resetAdyen () {
  return {
    type: RESET_ADYEN,
  }
}
